import React, { useEffect, useState } from 'react';
import searchIcon from '../../assets/icons/Minimalistic Magnifer.png'
import {
    initialFilters,
    gradeOptions,
    languageOptions,
    subjectsOptions
} from '../../models/library';
import BookItem from '../../components/library/BookItem';

import FilterSelect from '../../components/common/FilterSelect';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useGetListMutation } from '../../api/LibraryApi/LibraryService';

function Library(props) {
    const [filters, setFilters] = useState(initialFilters);
    const [books, setBooks] = useState([])

    const isAuth = useSelector(store=>store.auth.isAuth)
    const activeRole = useSelector(store=>store.user.activeRole);
    const username = useSelector(store=>store.user.username);
    const dispatch = useDispatch();
    const [ getList ] = useGetListMutation()
    const {t} = useTranslation();

    useEffect(() => {
        if(isAuth && username && activeRole) {
            onSearch();
        }
    }, [filters.grade, filters.subject, filters.publication_language, isAuth, username, activeRole])

    const onSearch = async () => {
        if (isAuth && username && activeRole) {
            const params = reformatParams({...filters, offset: 0, username, role: activeRole})
            const { data } = await getList(params);
            if (data && data.books) {
                setBooks(data.books)
            }
            setFilters({ ...filters, offset: 0})
        }
    }

    const reformatParams = (data)  => {
        let filterStr = '';
        for (const [key, value] of Object.entries(data)) {
            if (value) {
                if (filterStr === '') {
                    filterStr = `?${key}=${value}`
                } else {
                    filterStr = filterStr + `&${key}=${value}`
                }
            }
        }
        return filterStr;
    }

    return (
        <div className="px-2 flex-grow">
            <h1 className="text-3xl m-2 text-wrap">{t('general.header.examination')}</h1>
            <div className="desktop:flex">
                <div className="desktop:w-[405px]">
                    <div className="bg-dark-blue-color rounded-xl m-2 p-4 relative">
                        <input
                            className="w-full rounded-lg p-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
                            placeholder={t('libraryPage.search.searchPlaceholder')}
                            disabled={!isAuth}
                            id="search"
                            value={filters.input_text}
                            onChange={e => setFilters({...filters, input_text: e.target.value})}
                        />
                        <label htmlFor="search" className="absolute right-8 top-6 hover:cursor-pointer">
                            <img src={searchIcon} alt="search" onClick={onSearch}/>
                        </label>
                    </div>
                    <div className="bg-card-bg rounded-xl m-2 p-4 flex flex-col tablet:flex-row tablet:flex-wrap desktop:flex-col">
                        <div className="tablet:w-1/2 desktop:w-full">
                            <FilterSelect
                                name="grade"
                                label={t('libraryPage.search.class')}
                                disabled={!isAuth}
                                options={gradeOptions}
                                setState={setFilters}
                                state={filters}
                                className="tablet:mr-2 desktop:mr-0"
                            />
                        </div>
                        <div className="tablet:w-1/2 desktop:w-full">
                            <FilterSelect
                                name="subject"
                                label={t('libraryPage.search.subject')}
                                disabled={!isAuth}
                                options={subjectsOptions}
                                setState={setFilters}
                                state={filters}
                                className="tablet:mr-2 desktop:mr-0"
                            />
                        </div>
                        <div className="tablet:w-1/2 desktop:w-full">
                            <FilterSelect
                                name="publication_language"
                                label={t('libraryPage.search.language')}
                                disabled={!isAuth}
                                options={languageOptions}
                                setState={setFilters}
                                state={filters}
                                className="tablet:mr-2 desktop:mr-0"
                            />
                        </div>
                    </div>
                </div>
                <div className={`desktop:w-[900px]`}>
                    {isAuth &&
                        <>
                            <div className="p-2">
                                <button
                                    className={`${filters.grade === ''? 'btn-primary-library' : 'btn-secondary-border-library'} mx-1 mb-1 w-[95px]`}
                                    disabled={!isAuth}
                                    onClick={()=> setFilters({...filters, grade: ''})}
                                >
                                    {t('libraryPage.classes.all')}
                                </button>
                                {[...Array(11)].map((_, index) => (
                                    <button
                                        key={index}
                                        className={`${
                                            filters.grade === index + 1 ? 'btn-primary-library' : 'btn-secondary-border-library'
                                        } mx-1 mb-1 w-[95px]`}
                                        onClick={() => setFilters({ ...filters, grade: index + 1 })}
                                        disabled={!isAuth}
                                    >
                                        {t(`libraryPage.filters.grade.${index + 1}`)}
                                    </button>
                                ))}
                            </div>
                            <div className="p-4">
                                <span className="font-bold">{t('libraryPage.books.found')}: {books.length}</span>
                            </div>
                            <div className="flex flex-wrap mb-6 justify-start">
                                {
                                    books.map((book, index) => {
                                        return (
                                            <BookItem key={index} book={book}/>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default Library;
